<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  mounted() {
    // 获取网站设置
    this.fetchSiteSettings();
    // 检测推广参数
    this.trackReferral();
  },
  methods: {
    async fetchSiteSettings() {
      try {
        const response = await axios.get('/settings');
        if (response.data.siteName) {
          document.title = response.data.siteName;
        }
      } catch (e) {
        console.log('Failed to fetch site settings');
      }
    },
    async trackReferral() {
      const urlParams = new URLSearchParams(window.location.search);
      const ref = urlParams.get('ref');
      
      if (ref) {
        // 保存推广ID到localStorage
        localStorage.setItem('promoterId', ref);
        
        // 调用API记录访问
        try {
          await axios.post('/track/visit', {
            promoterId: ref
          });
          console.log('Referral tracked:', ref);
        } catch (e) {
          console.log('Failed to track visit:', e.message);
        }
        
        // 清除URL中的ref参数，保持URL干净
        if (window.history.replaceState) {
          const cleanUrl = window.location.pathname + window.location.hash;
          window.history.replaceState({}, document.title, cleanUrl);
        }
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background-color: #f7f8fa;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}
</style>
